module.exports = __webpack_public_path__ + "media/components/country-flag/static/kw-3ad37b74c2e984ff66040f58c643f936.svg";